<div class="legal-modal d-flex flex-column">
  <div class="legal-header px-4 pt-3 pb-0 position-relative">
    <!-- PNG rather than the SVG: html2canvas rasterises SVGs unreliably — on iOS
         Safari especially — painting them at intrinsic size, which left the logo cut
         off in the consent capture. This asset is already 103x32, so it is drawn 1:1. -->
    <img src="assets/images/icons/fm-logo.png" alt="Finance Mutual"
      class="legal-logo" width="103" height="32">

    <img src="assets/images/icons/cross-icon.svg" alt="Close"
      class="position-absolute top-0 end-0 mt-3 me-4 cursor legal-close" (click)="close()">

    <div class="legal-tabs d-flex mt-2">
      @for (doc of docs; track doc.key) {
        <button type="button" class="legal-tab fs-16 fw-500"
          [class.active]="active === doc.key" [disabled]="!isUnlocked(doc.key)"
          (click)="select(doc.key)">
          {{ doc.label }}
        </button>
      }
    </div>
  </div>

  <div class="legal-body px-4 py-3 flex-fill" #docBody (scroll)="onBodyScroll()">
    @if (current.loading) {
      <p class="fs-14 text-secondary m-0">Loading {{ current.label }}…</p>
    }
    @if (current.failed) {
      <div class="py-2">
        <p class="fs-14 text-danger mb-2">
          We couldn’t load the {{ current.label }}. Please check your connection and try again.
        </p>
        <button type="button" class="btn btn-default fs-14 fw-700" (click)="retry(current)">
          Retry
        </button>
      </div>
    }
    @if (current.html) {
      <div class="legal-content" [innerHTML]="current.html | safeHtml"></div>
    }
  </div>

  <div class="legal-footer px-4 py-3">
    <!-- Tells the user why there is nothing to accept yet. Drops away as soon as
         the document has been read to the end. -->
    @if (hasName && !readTerms) {
      <button type="button" class="legal-hint legal-scroll-cue fs-13 m-0 mb-2"
        (click)="scrollToBottom()">
        <span class="legal-arrow" aria-hidden="true"></span>
        Scroll to the end to accept
      </button>
    }

    @if (hasName && readTerms) {
      <!-- The whole row toggles. The input is display:none (global stylesheet) and
           the visible box is the label's ::before/::after, so the click is handled
           here rather than relying on label-for to reach a hidden control. -->
      <div class="legal-accept d-flex align-items-start fs-14 fw-400 mb-2 cursor"
        role="checkbox" [attr.aria-checked]="accepted" tabindex="0"
        (click)="toggleAccepted()"
        (keydown.space)="$event.preventDefault(); toggleAccepted()"
        (keydown.enter)="toggleAccepted()">
        <input type="checkbox" class="secondary-checkbox green-bg"
          [checked]="accepted" name="legalAccept" tabindex="-1" aria-hidden="true">
        <label class="legal-accept-box"></label>
        <span>
          I, <span class="legal-name">{{ businessName }}</span>, accept the
          <span class="legal-link">Terms & Conditions</span> and 
          <span class="legal-link">the Privacy Policy</span>.
        </span>
      </div>
    }

    <!-- Without a name there is nobody to record consent against, so the modal is
         read-only: the documents stay readable but no action is offered. -->
    @if (hasName) {
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-default fs-16 fw-700"
          [disabled]="accepting" (click)="decline()">Decline</button>
        <!-- Disabled for the whole capture: it runs for a moment on a phone, and
             a second tap would record the consent twice. -->
        <button type="button" class="btn btn-secondary fs-16 fw-700 legal-accept-btn"
          [disabled]="!accepted || !canAccept || accepting" (click)="accept()">
          <!-- The spinner is excluded from the capture: the record should show the
               button as it was when the user clicked it, not mid-save. -->
          @if (accepting) {
            <span class="legal-spinner" data-consent-exclude aria-hidden="true"></span>
          }
          Accept
        </button>
      </div>
    }
  </div>
</div>
